// extracted by mini-css-extract-plugin
export default {"section":"PageSectionLayout_section__Ze3-P","sectionContentContainer":"PageSectionLayout_sectionContentContainer__j0T6P"};